import * as sdcCommands from '@eika-dagligbank/sdc-mobilbank-lib';
import $ from 'jquery';

window.eika = {
  ...window.eika,
  ...sdcCommands
};

export default () => {

  $(() => {

    $('[data-native-action]')
      .on('click', event => {
          const el = event.currentTarget;
          const action = el.getAttribute('data-native-action');
          if (action && sdcCommands.sdcActions[action]) {
            event.preventDefault();
            sdcCommands.sdcActions[action]();
          }
      });

  });

};
